import { useCompanyEnrollmentInfo } from '../../../common/useCompanyEnrollmentInfo';
import AuthenticatedRoute from '../../AuthenticatedRoute';
import { OnboardHDHome } from './OnboardHDHome';

export function OnboardHDHomeWrapper() {
  // check company enrollment status
  useCompanyEnrollmentInfo({
    calledFromOnboardingComponent: false,
    enableOnboardingFlowTestRedirect: true,
  });

  return (
    <AuthenticatedRoute>
      <OnboardHDHome />
    </AuthenticatedRoute>
  );
}
